export default "__VITE_ASSET__DCPQ92I5__"